import type { WalletName } from '@solana/wallet-adapter-base';

export interface WalletCatalogEntry {
  /** Slug stored in API `wallet_provider` */
  slug: string;
  /** Adapter `WalletName` */
  adapterName: WalletName;
  label: string;
  installUrl: string;
  /** Optional square icon override */
  icon?: string;
  /** Short hint for users without the extension */
  detectHint?: string;
}

export const SOLANA_WALLET_CATALOG: WalletCatalogEntry[] = [
  {
    slug: 'phantom',
    adapterName: 'Phantom' as WalletName<'Phantom'>,
    label: 'Phantom',
    installUrl: 'https://phantom.app/download',
  },
  {
    slug: 'solflare',
    adapterName: 'Solflare' as WalletName<'Solflare'>,
    label: 'Solflare',
    installUrl: 'https://solflare.com/download',
  },
  {
    slug: 'backpack',
    adapterName: 'Backpack' as WalletName<'Backpack'>,
    label: 'Backpack',
    installUrl: 'https://backpack.app/download',
  },
  {
    slug: 'brave',
    adapterName: 'Brave' as WalletName<'Brave'>,
    label: 'Brave Wallet',
    installUrl: 'https://brave.com/wallet',
    detectHint: 'Enable Brave Wallet in the Brave browser',
  },
  {
    slug: 'nightly',
    adapterName: 'Nightly' as WalletName<'Nightly'>,
    label: 'Nightly',
    installUrl: 'https://nightly.app/',
  },
];

export function catalogEntryForAdapterName(name: WalletName): WalletCatalogEntry | undefined {
  return SOLANA_WALLET_CATALOG.find((e) => e.adapterName === name);
}

export function catalogEntryForProviderSlug(slug: string): WalletCatalogEntry | undefined {
  return SOLANA_WALLET_CATALOG.find((e) => e.slug === slug);
}

export function providerLabel(slug: string): string {
  return SOLANA_WALLET_CATALOG.find((e) => e.slug === slug)?.label ?? slug;
}
